import FrameworkCourseController from '../../../framework-course.controller';

class Diagram7Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 5;
    this.clearDiagramId = 4
    this.exerciseId = 'exercise-4'
    this.pyramidData = {
      exerciseNumber: 4,
      scheme: {
        model: {
          textarea: 'Eastwood has the qualities necessary to deliver and manage an outstanding new systems development facility for Spirit',
        },
        children: [
          {
            model: {
              textarea: 'We have a clear vision of the finished facility that Spirit needs',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'We will bring together the necessary levels of expertise to get the job done',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'We can move expeditiously to bring the whole project to life',
            },
            children: [

            ]
          }
        ],
      },
      scq: {
        's-header': 'Sit, R1-a, Sol-a',
        'c-header': 'R1-b, R2-b, Sol-b',
      },
    };
  }

}

export default Diagram7Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram7/diagram7.controller.js